import { cn } from '@magicdoorinc/ui';
import { Show } from 'solid-js';
import type { JSX, ParentComponent } from 'solid-js';

export const Section: ParentComponent<
  {
    title?: JSX.Element | string;
    titleJSX?: JSX.Element;
    actions?: JSX.Element;
    border?: boolean;
    required?: boolean;
    headerClass?: string;
    titleClass?: string;
  } & JSX.HTMLAttributes<Element>
> = (props) => {
  return (
    <div class={cn('mb-8 flex flex-col items-stretch', props.class)}>
      <div class={cn('mb-4 flex justify-between', { 'border-b border-separator pb-3': props.border }, props.headerClass)}>
        <Show
          when={props.titleJSX}
          fallback={
            <h2 class={cn('text-left text-base font-medium text-text-01', props.titleClass)}>
              {props.title}
              <Show when={props.required}>
                <span class="text-danger">*</span>
              </Show>
            </h2>
          }>
          {props.titleJSX}
        </Show>
        {props.actions}
      </div>
      {props.children}
    </div>
  );
};
